export const selectOrganisations = ({ organisations }) =>
  organisations && organisations.items ? organisations.items : [];

export const selectOrganisationsTotal = ({ organisations }) =>
  organisations && organisations.total ? organisations.total : 0;

export const selectCurrentOrganisation = ({ organisations }) =>
  organisations && organisations.currentOrganisation ? organisations.currentOrganisation : null;
